import { quickResultsReducerKey } from './QuickResultsConstants';

export function quickResults(state) {
  return state.get(quickResultsReducerKey);
}

export function isLoading(state) {
  return quickResults(state)?.get('isLoading');
}

export function allResults(state) {
  return quickResults(state)?.get('allResults');
}

export function previewResults(state) {
  return quickResults(state)?.get('previewResults');
}

export function structure(state) {
  return quickResults(state)?.get('structure');
}

export function structurePreview(state) {
  return quickResults(state)?.get('structurePreview');
}

export function query(state) {
  return quickResults(state)?.get('query');
}

export function isQueryEnabled(state) {
  return quickResults(state)?.get('isQueryEnabled');
}

export function isBioactivityVisualizationButtonEnabled(state) {
  return quickResults(state)?.get('isBioactivityVisualizationButtonEnabled');
}

export function isResultsPreviewReady(state) {
  return quickResults(state)?.get('isResultsPreviewReady');
}

export function shouldTrackSearchResults(state) {
  return quickResults(state)?.get('shouldTrackSearchResults');
}

export function requestId(state) {
  return quickResults(state)?.get('requestId');
}

export function searchId(state) {
  return quickResults(state)?.get('searchId');
}
